import { render, staticRenderFns } from "./LmLicensesView.vue?vue&type=template&id=01ffc897"
import script from "./LmLicensesView.vue?vue&type=script&lang=js"
export * from "./LmLicensesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports